export default "__VITE_ASSET__GN5Q5FVy__"